(function ($) {
  'use strict'
  ally.style.focusSource();
}) (jQuery)

function pushData(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...data });
}


function pushSocialEvent({
	event = 'ga-event',
	eventCategory = 'Social clicks',
	eventAction = 'clicks',
  eventLabel,
	eventValue = 'undefined',

  
}) {
	pushData({
		event,
		eventCategory,
		eventAction,
    eventLabel,
		eventValue,
	});
}

function pushErrorPageEvent({
	event = 'ga-event',
	eventCategory = 'Error pages',
	eventAction = 'views',
  eventLabel = '404',
	eventValue = 'undefined',
}) {
	pushData({
		event,
		eventCategory,
		eventAction,
		eventValue,
		eventLabel,
	});
}

function pushNewsletterSubscription({
	event = 'ga-event',
	eventCategory = 'Std Newsletter subscription',
	eventAction = 'clicks',
	eventValue = 'undefined',
	eventLabel = 'Standalone',
}) {
	pushData({
		event,
		eventCategory,
		eventAction,
		eventValue,
		eventLabel,
	});
}